import React, { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { Route } from '../../../../assembler-server/types/Route';

interface ErrorProps {
  routes: Route[];
  resetErrorBoundary: () => void;
}

const ERROR_PATH = '/error';

const Title = styled.p`
  color: #00095b;
  font-size: 40px;
  font-weight: 300;
  margin-block: 20px;
  line-height: 45px;
  text-align: center;
`;

const Subtitle = styled.p`
  font-weight: 300;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  margin: 0 0 3px;
  text-align: center;
`;

export const Error = ({ routes, resetErrorBoundary }: ErrorProps) => {
  const hasErrorRoute = useMemo(() => routes.some((route) => route.path === ERROR_PATH), [routes]);
  if (hasErrorRoute) {
    resetErrorBoundary();
    return <Navigate to={ERROR_PATH} />;
  }

  return (
    <>
      <Title>Something went wrong</Title>
      <Subtitle>
        We’re having trouble right now. Please try again after sometime or contact our support team if the issue continues.
      </Subtitle>
    </>
  );
};
